import { headerKey } from '@shared/helpers/kalkylfil-csv.parser';
import type { KalkylfilColumnMap } from '@shared/helpers/kalkylfil-csv.parser';
import type { ProjectElementImport } from '@shared/models/element-import.model';

const mappedHeaderKeys = (columnMap: KalkylfilColumnMap): Set<string> =>
  new Set(
    Object.values(columnMap)
      .filter((h): h is string => !!h)
      .map(headerKey),
  );

/** CSV headers present in the file but not mapped to a Nodon import field. */
export const importHasUnusedColumns = (
  imp: Pick<ProjectElementImport, 'headers' | 'columnMap'>,
): boolean => {
  const mapped = mappedHeaderKeys(imp.columnMap);
  return imp.headers.some((h) => !mapped.has(headerKey(h)));
};
